// Load default Webentor JS features
import './_header';

import CitySelect from './_city-select';
import Lightbox from './_lightbox';

// Register Alpine last to ensure all extensions are registered
import './_alpine';
import './_circular-text-adjuster';

// Register static assets
import.meta.glob(['../images/**', '../fonts/**'], {
  eager: true,
  query: '?url',
  import: 'default',
});

new Lightbox();
new CitySelect();
